
        var result = require("!!../../../../node_modules/css-loader/index.js!./results.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/tenders/results.component.css
// module id = 1464
// module chunks = 0